var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('JobStatusList'),(_vm.showProjectTab === true)?_c('ProjectStatusList'):_vm._e(),_c('HelloWorld')],1)}
var staticRenderFns = []

export { render, staticRenderFns }